const countriesWithoutPostalCodes = [
  "AE",
  "AG",
  "AI",
  "AO",
  "AS",
  "AW",
  "BF",
  "BI",
  "BJ",
  "BO",
  "BS",
  "BW",
  "BZ",
  "CF",
  "CG",
  "CI",
  "CK",
  "CM",
  "CW",
  "DG",
  "DM",
  "ER",
  "FJ",
  "FK",
  "GD",
  "GH",
  "GI",
  "GM",
  "GQ",
  "GS",
  "GY",
  "HK",
  "HM",
  "IO",
  "KN",
  "KP",
  "LC",
  "LY",
  "ML",
  "MO",
  "MR",
  "NF",
  "NR",
  "NU",
  "PA",
  "PN",
  "PW",
  "QA",
  "RW",
  "SC",
  "SH",
  "SR",
  "SS",
  "ST",
  "SY",
  "TC",
  "TD",
  "TK",
  "TO",
  "TV",
  "TZ",
  "UG",
  "UM",
  "VA",
  "VU",
  "YE",
  "ZM",
];

export default countriesWithoutPostalCodes;
